import { useTranslation } from 'react-i18next';
import { Grid, Typography, useTheme } from '@mui/material';

import {
  Checkbox,
  Container,
  DropDownCheckboxList,
  Select,
  TextField,
} from '../../components';
import { InventoryClass } from '../../enums';
import { CompanyFormProps } from './CompanyForm.props';

export const CompanyForm = ({ form }: CompanyFormProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <>
      <Container backgroundColor={theme.palette.secondary.light} sx={{ pb: 5 }}>
        <Grid container>
          <Grid item xs={12} md={6} sx={{ pr: { md: '20%' } }}>
            <Typography component="h3" variant="h3" sx={{ mt: 8, mb: 4 }}>
              {t('users.form.sections.companyProfileInformation')}
            </Typography>

            <TextField
              form={form}
              field="name"
              label={t('details.companies.fields.corporateCompanyName')}
              maxLength={255}
              required
            />
          </Grid>

          <Grid item xs={12} md={6} sx={{ pr: { md: '20%' } }}>
            <Typography component="h3" variant="h3" sx={{ mt: 8, mb: 4 }}>
              {t('users.form.sections.inventory')}
            </Typography>

            <DropDownCheckboxList
              form={form}
              label={t('companies.fields.canSeeCSAOrUL')}
              fields={['canSeeCSA', 'canSeeUL']}
              fieldLabels={[
                t('companies.fields.canSeeCSA'),
                t('companies.fields.canSeeUL'),
              ]}
              required
            />

            <Select
              required
              form={form}
              field="class"
              label={t('companies.fields.inventoryClass')}
              options={Object.values(InventoryClass)}
              getOptionLabel={(inventory) => t(`inventoryClasses.${inventory}`)}
            />

            <Checkbox
              field="allowPartialCuts"
              form={form}
              variant="medium"
              label={t('companies.fields.partialCuts')}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};
